import { StaffResponseType } from '../staff/types';

import {
  ApproveStaffParams,
  CreateProjectParams,
  ImportProjectStaffRequestType,
  ImportProjectStaffResponseType,
  PermissionFromProject,
  ProjectDataTypes,
  ProjectPayrollDataTypes,
  StaffProjectItemTypes
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllProjectService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<ProjectDataTypes[]>> => {
  const res = await axiosInstance.get('projects', { params });
  return res.data;
};

export const getProjectByIdService = async (
  id: string,
): Promise<ProjectDataTypes> => {
  const res = await axiosInstance.get(`projects/${id}`);
  return res.data.data;
};

export const getPermissionFromProjectByIdService = async (
  id: string,
  params: {
    staffFullTimeId: string,
  }
): Promise<PermissionFromProject> => {
  const res = await axiosInstance.get(`projects/${id}/can-do`, { params });
  return res.data.data;
};

export const createProjectService = async (
  params: CreateProjectParams,
): Promise<{ id: number }> => {
  const res = await axiosInstance.post('projects', params);
  return res.data.data;
};

export const updateProjectService = async (
  params: CreateProjectParams & { id: string },
): Promise<void> => {
  const { id, ...rest } = params;
  await axiosInstance.put(`projects/${id}`, rest);
};

export const deleteProjectsService = async (params: { ids: number[] })
  : Promise<void> => {
  const res = await axiosInstance.delete('projects', { data: params });
  return res.data;
};

export const updateStatusProjectService = async (id: number, status: boolean)
  : Promise<void> => {
  await axiosInstance.put(`projects/${id}/update-status`, { isLinkOpened: status });
};

export const updateStatusProjectWithManyIdService = async (ids: number[], status: boolean)
  : Promise<void> => {
  const res = await axiosInstance.put('projects/update-status-with-many-id', { isLinkOpened: status, ids });
  return res.data;
};

export const getStaffProjectByIdService = async (
  id: number,
  params?: BaseFilterParams & { approved?: boolean },
): Promise<APIPaginationResponse<StaffProjectItemTypes[]>> => {
  const res = await axiosInstance.get(`projects/${id}/staffs`, { params });
  return res.data;
};

export const approveStaffProjectService = async (params: ApproveStaffParams)
  : Promise<void> => {
  await axiosInstance.put(`projects/payroll-period/${params.payrollPeriodId}/approved`, { staffIds: params.staffIds, approved: params.approved });
};

export const declineStaffProjectService = async (params: ApproveStaffParams)
  : Promise<void> => {
  await axiosInstance.put(`projects/payroll-period/${params.payrollPeriodId}/declined`, { staffIds: params.staffIds });
};

// API đang không dùng
export const createProjectPayrollService = async (
  params: {
    id: number,
    payrollIds: number[]
  },
): Promise<void> => {
  await axiosInstance.post(`projects/${params.id}/store-payroll`, params);
};

export const getPayrallFromProjectService = async (
  projectId: string,
  staffId: string,
  params?: BaseFilterParams,
): Promise<ProjectPayrollDataTypes> => {
  const res = await axiosInstance.get(`projects/${projectId}/payroll/${staffId}`, { params });
  return res.data.data;
};

export const getStaffFromPayRallProjectService = async (
  payrollPeriodId: string,
  params?: BaseFilterParams & { approved?: boolean },
): Promise<APIPaginationResponse<StaffProjectItemTypes[]>> => {
  const res = await axiosInstance.get(`projects/payroll-period/${payrollPeriodId}/staff-part-time`, { params });
  return res.data;
};

export const updateLinkOpenService = async (
  payrollPeriodId: string,
  params: { isLinkOpened: boolean }
): Promise<void> => {
  await axiosInstance.put(`projects/payroll-period/${payrollPeriodId}/update-link-open`, params);
};

export const checkStaffByIdCardProjectService = async (
  payrollPeriodId: string,
  params: { idCardNumber: string },
): Promise<StaffResponseType> => {
  const res = await axiosInstance.get(`projects/payroll-period/${payrollPeriodId}/find-staff`, { params });
  return res.data.data;
};

export const addAndApproveStaffProjectService = async (
  payrollPeriodId: string,
  data: {
    idCardNumber: string
  }
): Promise<void> => {
  await axiosInstance.post(`projects/payroll-period/${payrollPeriodId}/add-and-approve`, data);
};

export const importProjectStaffService = async (
  params: ImportProjectStaffRequestType,
): Promise<ImportProjectStaffResponseType> => {
  const bodyForm = new FormData();
  bodyForm.append('file', params.file);
  bodyForm.append('preview', params.preview ? '1' : '0');

  const res = await axiosInstance.post(`projects/payroll-period/${params.payrollPeriodId}/import-staff`, bodyForm);
  return res.data.data;
};

export const importProjectStaffTemplateService = async (payrollPeriodId: string):
  Promise<{ link: string }> => {
  const res = await axiosInstance.post(`projects/payroll-period/${payrollPeriodId}/import-staff-template`);
  return res.data.data;
};
